import React, { useState, useEffect, useRef, useCallback } from 'react';
import styled from 'styled-components';
import { Form, Input, Checkbox, List, Button, InputNumber, Drawer, Tabs, Space, Table, Tag, notification, Empty, Modal } from 'antd';
import axios from 'axios';
import * as _ from 'lodash';
import { Icon } from 'dlweb-components';
import { DownOutlined } from '@ant-design/icons';
import Breadcrumb from '../Breadcrumb';

const FavoritesBrowser = ({onDoubleClick, onFolderClick, onTemplateSelect, selectedRowKeys, tableHeight}) => {

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({total: 0});

  const getDocuments =(query) => {
    setLoading(true)
    let qs = `folderID=Favorites` +
              '&sortField=FileName' +
              '&sortDirection=asc' +
              '&take=50' +
              `&skip=${query.skip}` +
              `&page=${query.current}` +
              '&pageSize=50';

    query.filterText && (qs += `&filterText=${query.filterText}`)

    axios.get(`api/Documents/GetDocuments?${qs}`).then(res => {
      setPagination({total: res.data.TotalRows})
      setData(res.data.Data)
      setLoading(false)
    })
  }

  useEffect(() => {
    getDocuments({skip: 0, current: 1});
  }, [])

  const onBreadcrumbClick = (path) => {
    getDocuments(path.path);
  }

  const handleTableChange = (paging, filters, sorter) => {

    const pager = { ...paging };
    pager.current = paging.current;
    setPagination(pager);

    const query = {
      ...pager,
      skip: (paging.current - 1) * paging.pageSize,
      filterText:  filters.FileName ? filters.FileName[0] : ''
    }

    getDocuments(query);
  };


  const columns = [
    {
      title: 'Name',
      dataIndex: 'FileName',
      key: 'FileName',
      render: (text, item) => <div>
                          {item.ObjectType === 'fod' &&
                            <div>
                              <img width="24px" height="18px" style={{float: 'left', display: 'inline-block', marginRight: '10px', marginTop: '2px'}} src="/images/folder.png" />
                            </div>
                          }
                          {item.ObjectType !== 'fod' &&
                            <div className={`file-icon-small files-small-${item.ObjectType}`} style={{ marginRight: '10px', marginTop: '2px'}}></div>
                          }
                          {`${item.FileName}${item.ObjectType === 'fod'|| !item.ObjectType  ? '' : '.' + item.ObjectType}`}
                        </div>,
    },
    {
      title: 'Created',
      dataIndex: 'CreateDate',
      key: 'CreateDate',
    }
  ];
  
  const navigateFolder = record => {
    if(record.ObjectType === 'fod') {
        onFolderClick(record.ID);
    }
  }
  
  const selectDocument = record => {
    if(record.ObjectType !== 'fod') {
      onTemplateSelect(record);
    }
  }

  return (
    <Container tableHeight={tableHeight}>
      <BreadcrumbContainer>
        <Breadcrumb paths={[{ path: 'Favorites', breadcrumbName: 'Favorites' }]} onClick={onBreadcrumbClick} />
      </BreadcrumbContainer>
      <Table
        rowKey="ID"
        size="small"
        loading={loading}
        columns={columns}
        dataSource={data}
        scroll={{y: tableHeight}}
        rowSelection={{
          hideSelectAll: true,
          selectedRowKeys: selectedRowKeys
        }}
        pagination={{
          position: ['bottomLeft'],
          total: pagination.total,
          showSizeChanger: false,
          defaultPageSize: 50,
          defaultCurrent: 1
        }}
        onChange={handleTableChange}
        onRow={(record) => ({
          onClick: () => {
            if(record.ObjectType === 'fod') {
              navigateFolder(record)
            }
            else {
              selectDocument(record)
            }
          },
          onDoubleClick: () => onDoubleClick(record)
        })}
      />
    </Container>
  );
};

const Container = styled.div`
  .ant-pagination {
    margin: 10px 0 0 0 !important;
  }
  .ant-table-body {
    overflow: auto;
    height: ${p => p.tableHeight + 'px'};
    .ant-table-row {
      cursor: pointer;
    }
  }
`

const BreadcrumbContainer = styled.div`
  width: 100%;
  height: 50px;
  line-height: 50px;
`

export default FavoritesBrowser;